"use client";
import { FunctionComponent, useRef, useState } from "react";
import {
  ClipboardDocumentCheckIcon,
  ClipboardIcon,
} from "@heroicons/react/24/outline";
import { Tooltip } from "../Tooltip/Tooltip";
import { cn } from "../../utils/cn";

export interface SmallCopyLinkProps {
  href: string;
  className?: string;
}

/**
 *
 */
export const SmallCopyLink: FunctionComponent<SmallCopyLinkProps> = ({
  href,
  className,
}) => {
  const [copied, setCopied] = useState(false);
  const [tooltip, setTooltip] = useState("Copy");
  const timeoutIdRef = useRef<any>(null);

  async function onClick() {
    await navigator?.clipboard?.writeText(href);
    setTooltip("Copied");
    setCopied(true);
    clearTimeout(timeoutIdRef.current);
    timeoutIdRef.current = setTimeout(() => {
      setCopied(false);
      setTooltip("Copy");
    }, 1000);
  }
  return (
    <div
      className={cn(
        "flex cursor-pointer items-stretch overflow-hidden rounded-lg border border-gray-300 text-gray-400",
        className,
      )}
    >
      <div className="w-1 flex-shrink flex-grow px-3 py-2 text-sm overflow-ellipsis text-ellipsis">
        {href}
      </div>

      <Tooltip label={tooltip}>
        <div
          className={cn(
            "grid w-10 place-items-center",
            copied ? "bg-green-500" : "bg-blue-500",
          )}
        >
          <button
            className="grid h-full w-full place-content-center"
            onClick={onClick}
          >
            {copied ? (
              <ClipboardDocumentCheckIcon className="h-5 w-5 stroke-white" />
            ) : (
              <ClipboardIcon className="h-5 w-5 stroke-white" />
            )}
          </button>
        </div>
      </Tooltip>
    </div>
  );
};
